import { render, staticRenderFns } from "./buy-now-gift-complete.vue?vue&type=template&id=bb2974d0&scoped=true&"
import script from "./buy-now-gift-complete.vue?vue&type=script&lang=js&"
export * from "./buy-now-gift-complete.vue?vue&type=script&lang=js&"
import style0 from "./buy-now-gift-complete.vue?vue&type=style&index=0&id=bb2974d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb2974d0",
  null
  
)

export default component.exports